<template>
  <VanPopup
    v-model:show="globalModal.showNewSiteMessageModal"
    class="max-h-[60%]"
    round
    safe-area-inset-top
  >
    <div class="card bg-base-100 border-none">
      <div class="card-body p-4">
        <!-- 标题栏 -->
        <div
          class="card-title flex justify-between items-center mb-3 pb-2 border-b border-base-300"
        >
          <div class="flex items-center gap-2">
            <span class="font-medium">{{
              globalModal.newSiteMessage.title
            }}</span>
          </div>
          <button
            @click="globalModal.showNewSiteMessageModal = false"
            class="btn btn-sm btn-circle btn-ghost"
          >
            ✕
          </button>
        </div>

        <div
          class="py-2 prose prose-sm"
          v-html="globalModal.newSiteMessage.content"
        />
      </div>
    </div>
  </VanPopup>
</template>

<script setup lang="ts">
import { useGlobalModal } from "@/stores/globalModal";
const globalModal = useGlobalModal();
</script>

<style scoped>
.status-1,
.status-2 {
  background: #fed500;
}

.status-3 {
  background: #00fe43;
}
</style>
